import { createFleetApiInstanceWithToken } from '../util';

const dashboard = {
    fetchStatistics(params) {
        return createFleetApiInstanceWithToken().get('/dashboards/fleet_statistics', { params });
    },
};

export default dashboard;
